import React, { FC } from 'react'
import { useLocation } from 'react-router-dom';  
const WhatsappIcon:FC = () => {
    const location = useLocation(); 
    const path = location.pathname;
if(path==="/bigcommerce-connection" || path.startsWith('/app-oauth/') || path==="/callback"){
  return null
}


  return (
    <div className="">
    <a href="https://wa.me/8085265399" target="_blank" rel="noopener noreferrer">
      <img
        src="https://constacloud.com/commercium/static/images/whatsapp-logo.png"
        alt="Whatsapp Logo"
        className="img-fluid"
        style={{
          position: 'fixed',
          bottom: '140px',
          right: '24px',
          width: '60px',
          height: '60px',
          cursor: 'pointer',
          zIndex: 99,
          transition: '.5s',
        }}
      />
    </a>
  </div>
  )
}

export default WhatsappIcon